import { NOT_IN_STORE } from "../constants/ActionTypes";
import { baseUrl } from '../constants/baseUrl';

export const createStripeAccountAction = (shopDetails, onSuccess, onFailure) => ({
    type: NOT_IN_STORE,
    payload: shopDetails,
    meta: {
        type: 'apijson',
        url: baseUrl + '/create_stripe_account',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {},
        options: {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(shopDetails)
        }
    }
}); 